/**
 * Thrown when pulling a statement fails (e.g. no data returned from backend).
 * This is an expected/operational error – treat as user-facing, not a bug.
 */
export class StatementPullError extends Error {
	readonly name = 'StatementPullError';

	constructor(message: string = 'There was an error pulling the statement. Please try again or choose a different period.') {
		super(message);
		Object.setPrototypeOf(this, StatementPullError.prototype);
	}
}
